/**
 * Build-time feature flags for the FunViz Analysis charts.
 *
 * These are plain constants (not env-driven) toggled in source and shipped
 * off/on with a commit — intended for features that are built but deliberately
 * not exposed yet, so the code stays in the tree and reviewed while the visible
 * behavior stays unchanged until the flag is flipped.
 */

/**
 * Vertical per-year gridlines on the main and ratio charts' datetime x-axis.
 * Implemented (a 1-year minor-gridline interval, matching the horizontal
 * y-gridline styling — see chartConfig.js / ratioChartConfig.js) but currently
 * OFF: flip to `true` to draw a subtle vertical line at every calendar-year
 * boundary. Note these land on calendar years, not per-company fiscal-year-ends
 * (no FY-end date is plumbed into the chart configs).
 */
export const VERTICAL_YEAR_GRIDLINES = false;

/**
 * Vertical per-year gridline x-axis options, spread into each chart's xAxis
 * (main + ratio) only when the VERTICAL_YEAR_GRIDLINES flag is on. A minor
 * gridline at every 1-year boundary (majors off, so their auto-thinned
 * multi-year ticks don't draw a heavier subset of lines), styled to match the
 * horizontal y-gridlines. Empty when the flag is off, so the axis keeps
 * Highcharts' defaults (no vertical gridlines). Lives here in the leaf config
 * module so both chart configs import it without coupling to each other.
 */
export const yearGridlineXAxisOptions = () => (
    VERTICAL_YEAR_GRIDLINES
        ? {
            gridLineWidth: 0,
            minorGridLineWidth: 1,
            minorGridLineColor: '#e6e6e6',
            minorTickInterval: 365 * 24 * 3600 * 1000,
        }
        : {}
);
